import styled, { css } from 'styled-components/macro'
import Box from 'components/shared/Box'

interface WrapperProps {
    crossedOutVariant?: 'gray' | 'yellow'
}

export const Wrapper = styled(Box)<WrapperProps>`
    position: relative;
    ${({ theme, crossedOutVariant }) =>
        crossedOutVariant &&
        css`
            ::before {
                position: absolute;
                left: 0;
                top: 50%;
                display: block;
                width: 100%;
                height: ${crossedOutVariant === 'gray' ? '2px' : '1px'};
                background-color: ${crossedOutVariant === 'gray'
                    ? theme.colors.grayscale_700
                    : theme.colors.primary_500};
                content: '';
                transform: translateY(-50%);
            }
        `}
`
